import PScrollbar from './src/main';

/* istanbul ignore next */
PScrollbar.install = function (Vue) {
    Vue.component(PScrollbar.name, PScrollbar);
};

export default PScrollbar;
